export default "__VITE_ASSET__Cw_Llv9G__"